<template>
    <div class="bottom-menu">
        <div class="bottom-menu-actions-container">
            <ul class="bottom-menu-items-container">
                <li class="bottom-menu-item"
                    v-for="(item, index) in visibleMenuItems" :key="index"
                    @click="goto(item.path)"
                    :class="{active: item.active}">
                        <fa :icon="item.icon" class="bottom-menu-icon" />
                        <p class="bottom-menu-text">{{item.description}}</p>
                </li>

                <li class="bottom-menu-item"                    
                    @click="toggleMoreActions()">
                        <fa icon="plus" class="bottom-menu-icon" />
                        <p class="bottom-menu-text">Mais</p>
                </li>
            </ul>
        </div>

        <div class="bottom-menu-more-actions-container" v-if="showMoreActions">
            <div class="bottom-menu-more-actions-name-container">
                <p>Mais ações</p>
            </div>

            <ul class="bottom-menu-more-actions-list">
                <li class="bottom-menu-more-actions-item" 
                    v-for="(action, index) in moreActions" :key="index"
                    @click="goto(action.path)">
                    <p class="bottom-menu-more-actions-item-description">{{action.description}}</p>
                    <fa icon="chevron-right" class="bottom-menu-more-actions-item-icon"/>
                </li>

                <li class="bottom-menu-more-actions-item item-logout" @click="logout()">
                    <p class="bottom-menu-more-actions-item-description">Sair</p>
                    <fa icon="power-off" class="bottom-menu-more-actions-item-icon" />
                </li>
            </ul>
        </div>
    </div>    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {logout} from '@/auth/services/SessionService';

export default {
    name: 'BottomMenuCmp',
    data() {
        return {
            showMoreActions: false,
            visibleMenuItems: [
                {
                    basePath: '/principal',
                    path: '/principal',
                    description: 'Principal',
                    icon: 'chart-line',
                    active: false,                    
                    isVisible: () => this.userAuthenticated.hasRoleAdmin(),
                },
                {
                    basePath: '/faturamento',
                    path: '/faturamento',
                    description: 'Faturamento',
                    icon: 'dollar-sign',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin(),
                },
                {
                    basePath: '/crm',
                    path: '/crm',
                    description: 'CRM',
                    icon: 'tasks',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin() || this.userAuthenticated.hasRoleSupport(),
                },
            ],
            moreActions: [
                {
                    basePath: '/clientes',
                    path: '/clientes',
                    description: 'Clientes',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin() || this.userAuthenticated.hasRoleBiller() || this.userAuthenticated.hasRoleSellerOperator() || this.userAuthenticated.hasRoleOperator(),
                },
                {
                    basePath: '/vendedores',
                    path: '/vendedores',
                    description: 'Vendedores',
                    active: false,
                    isVisible: () => this.userAuthenticated.hasRoleAdmin() || this.userAuthenticated.hasRoleBiller() || this.userAuthenticated.hasRoleSellerOperator() || this.userAuthenticated.hasRoleOperator(),
                },                
            ]
        }
    },
    methods: {
        goto(path) {
            this.showMoreActions = false

            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },
        toggleMoreActions() {
            this.showMoreActions = !this.showMoreActions
        },
        _activateRoute(path) {
            for (const item of this.visibleMenuItems) {
                item.active = false;
            }

            for (const item of this.visibleMenuItems) {
                const samePath = path === item.path
                const sameBasePath = path.indexOf(item.basePath) > -1

                if (samePath || sameBasePath) {
                    item.active = true;
                    break;
                }
            }           
        },
        async logout() {
            await logout()
        },
    },
    mounted() {
        this._activateRoute(this.$route.path)
    },
    computed: {
        ...mapState({
            subscriberList: state => state.subscriberList,
        }),
        ...mapGetters([
            'hasMoreThanOneSubscriber',
        ]),
    },
    watch: {
        $route(to, from) {
            this._activateRoute(to.path)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../utils/styles/constants.scss';

.bottom-menu {
    .bottom-menu-actions-container {
        position: fixed;
        background-color: #fff;
        left: 0;
        bottom: 0;
        width: 100vw;
        height: 65px;
        z-index: 10;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
        border-top: 1px solid #e4a679;

        ul.bottom-menu-items-container {
            list-style: none;
            width: auto;
            padding-left: 0;        
            padding: 10px 5px;
            text-align: center;

            li.bottom-menu-item {
                position: relative;
                display: inline-block;
                width: 25%;
                font-weight: 600;
                letter-spacing: 1px;

                &.active {
                    color: $color-primary;
                }

                .bottom-menu-text {
                    font-size: .7em;                    
                    text-transform: uppercase;
                }
            }
        }
    }

    .bottom-menu-more-actions-container {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
        background-color: #fff;

        ul {
            list-style: none;
            padding-left: 0;

            li {
                padding: 0 5px 15px;

                &:last-of-type {
                    padding-bottom: 0;
                }

                p {
                   margin-bottom: 0;
                }
            }
        }

        .bottom-menu-more-actions-name-container {
            font-size: 1.35em;
            text-transform: uppercase;
            font-weight: 600;
            margin-bottom: 15px;

            &:after {
                content: '';
                display: block;
                width: 35px;
                height: 3px;
                margin-left: 5px;
                background-color:#FF6B36;
            }
            
            p {
                padding: 5px 5px 0;
                margin-bottom: 0;
            }
        }

        .bottom-menu-more-actions-list {
            .bottom-menu-more-actions-item {
                position: relative;
                text-transform: uppercase;
                padding-bottom: 0;
                margin-bottom: 15px;

                &:last-of-type {
                    margin-bottom: 0;
                }

                p {
                    margin-bottom: 0;
                }
                
                .bottom-menu-more-actions-item-description {
                    
                }

                .bottom-menu-more-actions-item-icon {
                    position: absolute;
                    font-size: .8em;
                    top: 5px;
                    right: 5px;
                    color: #777;
                }
            }
        }
    }
}
</style>
